import React, { useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import DateRangeIcon from '@material-ui/icons/DateRange';
import { useTranslation } from "react-i18next";

import { RepLISlider } from "../../../components";

import useStyles from "./Page2.style";

const Page2 = props => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [childbearingYearFrame, setChildbearingYearFrame] = useState([18, 45]);

    useEffect(() => {
        const localStorageChildbearingYearFrame = localStorage.getItem('childbearingYearFrame') && localStorage.getItem('childbearingYearFrame').split(',');
        const propsChildbearingYearFrame = props.profile && props.profile.childbearingYearFrame;
        const storedChildbearingYearFrame = localStorageChildbearingYearFrame || propsChildbearingYearFrame;

        if (storedChildbearingYearFrame) setChildbearingYearFrame(storedChildbearingYearFrame);
    }, [props.profile]);

    const handleChildBearingYearFrameChange = (event, newValue) => {
        setChildbearingYearFrame(newValue);
        localStorage.setItem('childbearingYearFrame', newValue);
    };

    return (
        <>
            <Box className={classes.iconSection}>
                <DateRangeIcon className={classes.icon} />
            </Box>
            <Box className={classes.textSection}>
                <Typography component="div" className={classes.text}>
                    {t('repliQuestionnaire.general.childbearingFrame')}
                </Typography>
            </Box>
            <Box className={classes.inputSection}>
                <RepLISlider
                    value={childbearingYearFrame}
                    onChange={handleChildBearingYearFrameChange}
                    valueLabelDisplay="on"
                    min={15}
                    max={55}
                />
            </Box>
        </>
    );
};

export default Page2;